import React, { useState } from 'react';
import './FAQ.css';
import { FaqData } from '../../constants';

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = id => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div className="faq-container">
      <div className="faq-content">
        {FaqData?.rows?.map(item => (
          <div key={item.id} className="faq-item">
            <div className="faq-question" onClick={() => toggleItem(item.id)}>
              <span className="faq-question-text">{item.title}</span>
              <span
                className={`faq-arrow ${openItems[item.id] ? 'faq-arrow-up' : 'faq-arrow-down'}`}>
                &#9660;
              </span>
            </div>
            {openItems[item.id] && (
              <div className="faq-answer">
                <p>{item.content}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
